import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { useStore } from "vuex";
export default defineComponent({
  components: {
    Pagination: Pagination
  },
  props: {
    apiName: {
      required: true,
      type: String,
      default: ""
    },
    tabsIndex: {
      required: true,
      type: Number,
      default: 0
    },
    conditions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ["update:totalNum"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var userId = useStore().state.user.user.userId; //来源标示

    var source = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$tips_source;
    var myRecord = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$tipsText.$my_record; //表格数据

    var tableData = ref([]); // 分页属性

    var totalNum = ref(0);
    var pageIndex = ref(1);

    function initData() {
      totalNum.value = 0;
      pageIndex.value = 1;
      tableData.value = [];
      getTabledata();
    }

    function getTabledata() {
      return _getTabledata.apply(this, arguments);
    } // 分页跳转


    function _getTabledata() {
      _getTabledata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page, _yield$globalProperti, data, total, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = {
                  pageIndex: pageIndex.value,
                  pageSize: 10,
                  statuss: props.tabsIndex == 0 ? 2 : props.tabsIndex == 1 ? '2,4' : 5
                };
                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[props.apiName](Object.assign(page, props.conditions));

              case 3:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                code = _yield$globalProperti.code;

                if (code == 0) {
                  totalNum.value = total;
                  tableData.value = data;

                  if (props.tabsIndex == 1) {
                    emit("update:totalNum", total);
                  }
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTabledata.apply(this, arguments);
    }

    function changPage(val) {
      pageIndex.value = val;
      getTabledata();
    } //去报名


    function gosignUp(id) {
      if (props.tabsIndex == 0) {
        router.push({
          path: "/personal/meetingSignUp",
          query: {
            id: id
          }
        });
      } else {
        router.push({
          path: "/personal/meetingDetail",
          query: {
            id: id,
            flag: props.tabsIndex == 1 ? 0 : 1
          }
        });
      }
    }

    return {
      tableData: tableData,
      totalNum: totalNum,
      source: source,
      myRecord: myRecord,
      userId: userId,
      gosignUp: gosignUp,
      getTabledata: getTabledata,
      initData: initData,
      changPage: changPage
    };
  }
});